import { AppSidebar } from '@/components/AppSidebar';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { SidebarInset, SidebarProvider } from '@/components/ui/Sidebar';
import { LOGIN_ERROR_REASONS } from '@/features/auth/schemas/login.schemas';

export const Route = createFileRoute('/_auth')({
  beforeLoad: ({ context }) => {
    const { isAuthenticated, sessionExpired } = context.auth();

    if (!isAuthenticated) {
      throw redirect({
        to: '/login',
        search: { reason: sessionExpired ? LOGIN_ERROR_REASONS.session_expired : undefined },
      });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <div className="[view-transition-name:main-content] flex-1 content-stretch flex justify-center">
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
